import React from "react"
import { withStyles } from '@material-ui/core';
import { styles } from "./style";
import Header from "./Components/header"
import ByProperty from "./ByProperty"
import ByCampaign from "./ByCampaign"
import ContactList from "./Contact List"
import MyAnalytics from "./My Analytics"
import UserContext from 'context/UserContext';
import { getCampaigns } from "relay/campaigns"
import { loadProperties } from "relay/common"
import { getDropDownValues } from "./utils"
import Loading from "storybookComponents/Loader"
import * as path from 'constants/path'
import moment from "moment";
import ToastMessage from "storybookComponents/Toast"

const steps = {
  0: "/by-property",
  1: "/by-campaigns",
  2: "/by-contact",
  3: "/by-campaign",
}

const analyticsObject = {
  'By Property': 0,
  'Campaign Analytics': 3,
  'RAF Contact List': 2
}

const Report = ({ setPageTitle, classes, index, _view, history }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [subMenu, setSubMenu] = React.useState(index)
  const [loading, setLoading] = React.useState(true);
  const [allCampaignsByProperties, setAllCampaignsByProperties] = React.useState([]);
  const [propertiesOfOrg, setPropertiesOfOrg] = React.useState([]);
  const [allCampaigns, setAllCampaigns] = React.useState([]);
  const [view, setView] = React.useState("allCampaign");
  const [selectedCampaign, setSelectedCampaign] = React.useState()
  const [reportData, setReportData] = React.useState({})
  const [toast, setToast] = React.useState({ open: false })
  const [previewReport, setPreviewReport] = React.useState();

  React.useEffect(() => {
    if (_view !== "analytics") {
      setPageTitle('Refer a Friend - Reports');
      setSubMenu(index)
      setView(_view)
    } else {
      setPageTitle('Home');
    }
    if (!history.location.pathname.includes("preview")) {
      setPreviewReport(null)
    }
  }, [index, _view]);

  React.useEffect(() => {
    init();
  }, [1]);

  const handleSetSubMenu = (index) => {
    setSubMenu(index);
    history.push(path.getAppPath() + steps[index])
  }

  const handleSelectCampaign = (item) => {
    setView("singleCampaign");
    setSubMenu(1);
    setSelectedCampaign({
      id: item.campaignId,
      monthRange: { startAt: moment(item.createdAt).startOf("month"), endAt: moment(item.createdAt).endOf("month"), label: moment(item.createdAt).format('DD MMM YYYY') },
      ...item
    })
    history.push(path.getAppPath() + "/by-campaign")
  }

  const init = async () => {
    try {
      setLoading(true)
      await getAllCampaignsOfOrg();
      await getAllPropertiesOfOrg();
      setLoading(false)
    } catch (err) {
      console.log("err", err)
    }
  }

  const getAllPropertiesOfOrg = async () => {
    try {
      let response = await loadProperties(subOrgDetails.org.id)
      if (response && response.length > 0) {
        let properties = response.map((e) => {
          return {
            id: e.id,
            value: e.name
          }
        })
        setPropertiesOfOrg(properties)
      }
    } catch (err) {
      console.log("err", err)
    }
  }

  const handlePreviewClick = (preview) => {
    setPreviewReport(preview)
    history.push(path.getAppPath() + steps[analyticsObject[preview.analyzeObject]] + "/preview")
  }


  const getAllCampaignsOfOrg = async () => {
    try {
      let response = await getCampaigns(subOrgDetails.org.id);
      if (response.sorted) {
        let campaigns = response.sorted.map(e => e.node);
        setAllCampaigns(campaigns)
        setAllCampaignsByProperties(getDropDownValues(campaigns));
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const showNotification = (message, type) => {
    setToast({
      open: true,
      variant: type,
      message
    })
  }

  const closeToast = () => {
    setTimeout(() => {
      setToast({
        open: false,
        variant: toast.variant
      })
    }, 5000)
  }

  const forceCloseToast = () => {
    setToast({
      open: false,
      variant: toast.variant
    })
  }

  return (
    <div>
      <ToastMessage
        variant={toast.variant}
        message={toast.message}
        open={toast.open}
        onCloseCallback={closeToast}
        onForceCloseCallback={forceCloseToast}
      />
      {
        loading || (propertiesOfOrg.length == 0) ?
          <Loading /> :
          _view == "analytics" ? <MyAnalytics handlePreviewClick={handlePreviewClick} allCampaigns={allCampaigns} propertiesOfOrg={propertiesOfOrg} showNotification={showNotification} /> :
            <>
              <Header
                index={index}
                setSubMenu={handleSetSubMenu}
                reportData={reportData}
                subOrgDetails={subOrgDetails}
                hideSaveReport={subMenu == 1 && view == "allCampaign"}
                showNotification={showNotification}
              />
              <div className={classes.root}>
                {

                  subMenu == 0 ?
                    <ByProperty
                      subOrgDetails={subOrgDetails}
                      subMenu={subMenu}
                      allCampaignsByProperties={allCampaignsByProperties}
                      propertiesOfOrg={propertiesOfOrg}
                      classes={classes}
                      history={history}
                      handleSelectCampaign={handleSelectCampaign}
                      setReportData={setReportData}
                      previewReport={previewReport}
                    /> : subMenu == 1 ?
                      <ByCampaign
                        subOrgDetails={subOrgDetails}
                        subMenu={subMenu}
                        allCampaignsByProperties={allCampaignsByProperties}
                        propertiesOfOrg={propertiesOfOrg}
                        classes={classes}
                        history={history}
                        view={view}
                        handleSelectCampaign={handleSelectCampaign}
                        setReportData={setReportData}
                        selectedCampaign={selectedCampaign || {
                          propertyId: subOrgDetails.id
                        }}
                        previewReport={previewReport}
                      /> :
                      <ContactList
                        subOrgDetails={subOrgDetails}
                        subMenu={subMenu}
                        allCampaignsByProperties={allCampaignsByProperties}
                        propertiesOfOrg={propertiesOfOrg}
                        classes={classes}
                        history={history}
                        handleSelectCampaign={handleSelectCampaign}
                        setReportData={setReportData}
                        previewReport={previewReport}
                      />
                }
              </div>
            </>}
    </div>
  )
}

export default withStyles(styles)(Report)